<template>
  <div id="read-aloud-info">
    <div class="base-create">
      <div>
        <el-row class="mb-px-16">
          <el-col :span="8">
            <div class="info-row">
              <p>
                <span class="label">{{ $t($i18nLabelsHelper(currentOrganizationType, `teacher`)) }}:</span>
                <span class="value">{{ readAloudDetails.owner_name }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-row">
              <p>
                <span class="label">{{ $t(`study_sets.table.shareable_to`) }}:</span>
                <span class="value">{{
                  $t($i18nLabelsHelper(currentOrganizationType, `study_sets.${readAloudDetails.shareable}`))
                }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row class="mb-px-16">
          <el-col :span="8">
            <div class="info-row">
              <p>
                <span class="label">{{ $t(`study_sets.table.last_updated`) }}:</span>
                <span class="value"> {{ formatDate(readAloudDetails.updated_at) }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-row">
              <p>
                <span class="label"
                  >{{ $t($i18nLabelsHelper(currentOrganizationType, `study_sets.assigned_groups`)) }}:</span
                >
                <span class="value">{{ assigned_group.length }}</span>
              </p>
            </div>
          </el-col>
          <!-- <el-col :span="8">
            <div class="info-row">
              <p>
                <span class="label">{{$t(`study_sets.phrases_count`)}}:</span> <span class="value">{{ studysetDetails.phrases_count }}</span>
              </p>
            </div>
          </el-col> -->
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="info-row mb-px-16 reading-content">
              <p :style="{ display: 'flex', 'justify-content': 'space-between' }">
                <span class="label">{{ $t(`read_aloud.detail.reading_content`) }}</span>
                <button-preview-audio
                  v-if="readAloudDetails.audio_url"
                  :audio-link="readAloudDetails.audio_url"
                  :speed="audioSpeed"
                />
              </p>
              <p class="value">{{ readAloudDetails.passage }}</p>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="readAloudDetails.warm_up_ss">
          <el-col :span="24">
            <div id="phrases-wrapper">
              <div class="info-row mb-px-16">
                <p>
                  <span class="label">{{ $t(`read_aloud.warm_up.title`) }}</span>
                </p>
              </div>
              <ul class="list-none" id="phrases-list">
                <li v-for="phrase in readAloudDetails.warm_up_ss.phrases" :key="phrase.text">
                  <el-tooltip content="This phrase was successfully added" placement="top-start"></el-tooltip>
                  <div class="phrase">
                    {{ phrase.text }}
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { format } from "date-fns";
import { DATE_FORMAT } from "@/constants/generic";
import ButtonPreviewAudio from "@/components/common/GenerateAudioTTS/ButtonPreviewAudio.vue";

export default {
  components: { ButtonPreviewAudio },
  props: {
    readAloudDetails: {},
    organizationType: {},
    organizationId: {},
    dateFormat: {
      type: String,
      default: DATE_FORMAT,
    },
  },
  data() {
    return {
      loading: null,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
    }),
    ...mapState("readAlouds", ["isLoadingEdit", "audioSpeed"]),
    assigned_group() {
      return this.readAloudDetails && this.readAloudDetails.assigned_group ? this.readAloudDetails.assigned_group : [];
    },
  },
  methods: {
    formatDate(date) {
      return date ? format(new Date(date), this.dateFormat) : "--";
    },
  },
  watch: {
    isLoadingEdit(status) {
      if (status) {
        this.loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      } else {
        this.loading && this.loading.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";
h3 {
  text-transform: none;
}
p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin: 0;
}

#read-aloud-info {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 24px 32px;
  margin-bottom: 24px;
}

.info-row {
  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #757575;
    margin: 0;
    text-align: initial;
  }

  .value {
    color: $black;
    text-transform: none;
    margin-bottom: 4px;
  }

  // .values {
  //   margin-top: 5px;
  //   p {
  //     color: $black;
  //     text-transform: none;
  //     margin-bottom: 4px;
  //     font-weight: 500;
  //   }
  // }
  // p {
  //   font-weight: 600;
  //   font-size: 17px;
  //   color: $dark-blue-2;
  //   margin: 0;
  //   text-align: initial;
  //   text-transform: capitalize;
  // }
}

.reading-content {
  background: #f1f1f1;
  border-radius: 8px;
  padding: 16px;
  .value {
    padding-top: 10px;
  }
}
#phrases-wrapper {
  background: #f1f1f1;
  border-radius: 8px;
  padding: 16px;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 8px #c2c2c2;
    border-radius: 100px;
  }
}

#phrases-list {
  overflow: auto;
  padding-left: 0px;
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  padding: 0;
  gap: 10px;
  flex-wrap: wrap;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c2c2c2;
    // box-shadow: inset 0 0 8px #C2C2C2;
    border-radius: 100px;
  }
  .spell-error {
    text-decoration-line: underline;
    color: #eb001b;
  }
  .cleanup-text {
    text-decoration-line: underline;
    color: #ff9f00;
  }
}

#phrases-list li {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  color: #121131;
  display: flex;
  .phrase {
    display: flex;
    border: 0.5px solid #cee0ea;
    background: #e9e9ec;
    padding: 6px 10px;
    border-radius: 4px;
    .el-icon-warning {
      font-size: 18px;
      color: #ff9f00;
      padding: 4px 6px 0px 0px;
    }
  }
}

.phrase {
  font-size: 14px;
  font-weight: 590;
  &--auto {
    background: #b6d1ff !important;
  }
}
</style>
